import request from '@/utils/request'

//获取订单状态
export function getOrderStatusSelect() {
  return request({
    url: '/select/getOrderStatusSelect',
    method: 'get'
  })
}

//获取办事处
export function getAgencySelect() {
  return request({
    url: '/select/getAgencySelect',
    method: 'get'
  })
}

//解密手机号  银行卡
export function decodeManager(data) {
  return request({
    url: '/decodeManager/decode',
    method: 'post',
    data: data
  })
}

//获取仪器类别
export function getDeviceCategory() {
  return request({
    url: '/constant/getDeviceCategory',
    method: 'get'
  })
}

//优惠券有效期类型
export function getCouponValidTypeSelect() {
  return request({
    url: '/select/getCouponValidTypeSelect',
    method: 'get'
  })
}

//发放群体
export function getCouponIssuanceGroupSelect() {
  return request({
    url: '/select/getCouponIssuanceGroupSelect',
    method: 'get'
  })
}

//供应商
export function getProviderSelect(data) {
  return request({
    url: '/select/getProviderSelect?deviceCode=' + data.deviceCode,
    method: 'post',
  })
}


//供应商(无仪器能力)
export function getProviderSelectNoConfig(data) {
  return request({
    url: '/select/getProviderSelectNoConfig?deviceCode=' + data.deviceCode,
    method: 'post',
  })
}
//获取操作日志
export function getOperRecords(params) {
  return request({
    url: '/orderEasy/getOperRecords',
    method: 'get',
    params
  })
}
//获取操作类型下拉选
export function getOperTypeList(params) {
  return request({
    url: '/orderEasy/getOperTypeList',
    method: 'get',
    params
  })
}

//仪器型号
export function deviceList(data) {
  return request({
    url: '/device/list',
    method: 'post',
    data: data
  })
}

//获取到款子公司
export function getSubCompanySelect() {
  return request({
    url: '/select/getSubCompanySelect',
    method: 'get',
  })
}

//获取后台管理人员list
export function getAdminManagerSelect(params) {  //params为nickName
  return request({
    url: '/admin/listAll',
    method: 'get',
    params
  })
}

//数据字典
export function findByBusiType(typeId) {
  return request({
    url: `mdictionary/findByBusiType/${typeId}`,
    method: 'post',
  })
}

// 数据字典v2
export function findByBusiTypeV2(typeId) {
  return request({
    url: `mdictionary/findBy/platform_info_config/${typeId}`,
    method: "post"
  });
}
//获取销售list
export function getSalesSelect() {
  return request({
    url: '/role/getRoleUsers?roleId=3',
    method: 'get',
  })
}

//获取技支list
export function getTechSupportSelect() {
  return request({
    url: '/role/getRoleUsers?roleId=10',
    method: 'get',
  })
}

//查询表头
export function tableGetOne(handleMenu) {
  return request({
    url: '/table/sort/getOne?handleMenu='+handleMenu,
    method: 'get',
  })
}
//仪器型号
export function tableSubmit(data) {
  return request({
    url: '/table/sort/submit',
    method: 'post',
    data: data
  })
}
// 销售海报
export function getRecommondMiniQrCode(data) {
  return request({
    url: '/admin/getRecommondMiniQrCode',
    method: 'post',
    data:data
  })
}

// 从客户池中获取企业数据
export function findList(data){
  return request({
    url: "/customer/supplier/findList",
    method: "post",
    data
  });
}


// WEBPACK FOOTER //
// ./src/api/common.js